import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class SmartPos {
  static init() {
    console.debug('== SmartPos component ==')

    const sectionSmartPos = document.querySelector(
      '.section--smart-pos.section--desktop'
    )

    if (sectionSmartPos && !isHidden(sectionSmartPos)) {
      console.debug('  -> Initializing smart pos video component desktop')

      const textWrapper = sectionSmartPos.querySelector('.section-left-wrapper')
      const videoInternalWrapper =
        sectionSmartPos.querySelector('.video-wrapper')
      const video = sectionSmartPos.querySelector('#smartpos-video')

      once(document.documentElement, 'touchstart', function (e) {
        video.play()
        video.pause()
      })

      let tl = gsap.timeline({
        defaults: {duration: 1},
        scrollTrigger: {
          trigger: textWrapper,
          // markers: true,
          start: 'top 18%',
          end: 'bottom 90%',
          pin: videoInternalWrapper,
          pinSpacing: false,
          pinType: 'fixed',
          scrub: true,
        },
      })

      once(video, 'loadedmetadata', () => {
        tl.fromTo(
          video,
          {
            currentTime: 0,
          },
          {
            currentTime: video.duration || 1,
          }
        )
      })
    }

    const sectionSmartPosMobile = document.querySelector(
      '.section--smart-pos.section--mobile'
    )

    if (sectionSmartPosMobile && !isHidden(sectionSmartPosMobile)) {
      console.debug('  -> Initializing smart pos video component mobile')

      const sectionMobileWrapper = sectionSmartPosMobile.querySelector(
        '.section-mobile-wrapper'
      )

      const textWrapper = sectionSmartPosMobile.querySelector(
        '.section-left-wrapper'
      )

      const videoWrapper = sectionSmartPosMobile.querySelector('.video-wrapper')

      const video = sectionSmartPosMobile.querySelector('#smartpos-video')

      once(document.documentElement, 'touchstart', function (e) {
        video.play()
        video.pause()
      })

      let tl = gsap.timeline({
        defaults: {duration: 1},
        scrollTrigger: {
          trigger: sectionSmartPosMobile,
          markers: false,
          start: '16% 3%',
          end: 'bottom 100%',
          pin: sectionMobileWrapper,
          pinSpacing: false,
          pinType: 'fixed',
          scrub: true,
        },
      })

      once(video, 'loadedmetadata', () => {
        tl.fromTo(
          video,
          {
            currentTime: 0,
          },
          {
            currentTime: video.duration || 1,
          }
        )
      })
    }
  }
}

function isHidden(element) {
  return element.offsetHeight === 0 && element.offsetWidth === 0
}

function once(el, event, fn, opts) {
  var onceFn = function (e) {
    el.removeEventListener(event, onceFn)
    fn.apply(this, arguments)
  }
  el.addEventListener(event, onceFn, opts)
  return onceFn
}
